import { Component } from '@angular/core';
import * as fromRoot from '../../../../common/reducers';
import * as auth from '../../../../common/actions/authentication';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthBusinessService } from '../../../../common/services/AuthBusiness.service';
import { Store } from '@ngrx/store';
declare var $: any;

// import { AuthGuard } from 'app/common/services/Auth.guard';

/**
 * This class represents the lazy loaded HomeComponent.
 */

@Component({
    selector: 'business-login',
    templateUrl: 'login-business.component.html',
    providers: [AuthBusinessService]
})

export class LoginBusinessComponent {
    public token: string;
    public role: string;

    constructor(
        private route: ActivatedRoute,
        private authBusinessService: AuthBusinessService,
        private store: Store<fromRoot.State>, private router: Router
    ) {
    }

    ngOnInit() {
        this.token = this.route.snapshot.queryParamMap.get('token');
        this.role = this.route.snapshot.queryParamMap.get('role') || 'business';
        if (this.token) {
            let mUser = {
                token: this.token,
                role: this.role,
                redirect_login : true
            };
            this.store.dispatch(new auth.LoginAction(mUser));
        } else {
            this.store.dispatch(new auth.LogoutAction());
            this.router.navigate(['']);
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/business/login-business.component.ts